import React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Paper } from '@material-ui/core';
import './index.scss';
import Navbar from '../../components/Navbar';
import CreateIcon from '@material-ui/icons/Create';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import { Helmet } from 'react-helmet';
import Classnames from 'classnames';

import { METADATA } from '../../constants';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    fontFamily: "Helvetica Neue",
  },
  paper:{
    backgroundColor: "#212529",
    minWidth:250,
    marginTop: 5,
    marginBottom:5,
    padding:5,
    '&:hover': {
      backgroundColor: "#fb8c00",
  },
  },
}));

export default function HandleTags() {
  // const theme = useTheme();
  const history = useHistory();
  // const isMobile = useMediaQuery(theme.breakpoints.up('sm'));

  const classes = useStyles();
  const handleRedirectToPage = (event) => {
    if (event.currentTarget.dataset.value === "tagged-playlist") {
      history.push("/tagged-playlist");
      window.location.reload();
    } else if (event.currentTarget.dataset.value === "tagged-content") {
      history.push("/tagged-content");
      window.location.reload();
    } else if (event.currentTarget.dataset.value === "handle-tags") {
      history.push("/handle-tags");
      window.location.reload();
    }
  }

  return (
    <>
      <Helmet>
        <meta name="description" content={METADATA.HANDLETAGS.description} />
        <title>{METADATA.HANDLETAGS.title}</title>
      </Helmet>
      <Navbar />
      <Grid container className="dashboard-content container" justify="center" >
        <Grid
          item
          className="dashboard-content main-menu"
          justify="center"
          xs={11}
          md={8}
          lg={11}
          style={{marginTop:100, marginLeft:0}}
        >
          <Grid container className="dashboard grid-items" justify="center" spacing={4}>
            <Grid key="1" item>
              <Paper className={Classnames("grid-paper1", classes.paper)} onClick={handleRedirectToPage} data-value="tagged-playlist">
                <div className="inner-content">
                  <CreateIcon style={{minWidth:100, minHeight:100}} />
                  <Grid className="titleNames">Tagged Playlist</Grid>
                </div>
              </Paper>
            </Grid>
            <Grid key="2" item>
              <Paper  className={Classnames("grid-paper1", classes.paper)} onClick={handleRedirectToPage} data-value="tagged-content">
                <div className="inner-content">
                  <LocalOfferIcon  style={{minWidth:100, minHeight:100}}/>
                  <Grid className="titleNames">Tagged Content</Grid>
                </div>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}